<template>
  <display-stat>
    <template #title>
      {{ label }}
    </template>

    <template #amount>
      {{ displayAmount(data) }}
    </template>
  </display-stat>
</template>

<script>
import { ref, computed } from 'vue'
import useStatistics from '@composables/statistics/use-statistics.js'
import useStates from '@composables/statistics/use-states.js'
import useNumbers from '@composables/use-numbers'
import DisplayStat from '@components/statistics/display-stat'

export default {
  props: {
    label: {
      type: [String, null],
      default: null,
    },

    usersType: {
      type: String,
      enum: ['', 'paid', 'free'],
      default: '',
    },
  },

  setup (props) {
    const { active, paidActive, freeActive } = useStates()

    const data = computed(() =>
      !props.usersType 
      ? active.value
      : props.usersType === 'paid' 
      ? paidActive.value
      : freeActive.value
    )

    return {
      data,
      ...useNumbers(),
    }
  },

  components: {
    DisplayStat
  }
}
</script>
